// extracted by mini-css-extract-plugin
export default {"email_form_label":"EmailFormLabel_email_form_label__eTjba","required_prefix":"EmailFormLabel_required_prefix__wIRsP","required_flag":"EmailFormLabel_required_flag__7XULC"};